(function () {
  var lastHeight = null;

  function updateChromeOffsets() {
    var headerEl = document.querySelector('l-header') || document.querySelector('.l-header__container');
    var headerHeight = headerEl ? Math.ceil(headerEl.getBoundingClientRect().height) : 72;
    if (!headerHeight) headerHeight = 72;
    if (headerHeight === lastHeight) return;

    lastHeight = headerHeight;
    document.documentElement.style.setProperty('--a-header-offset', headerHeight + 'px');
    document.documentElement.style.setProperty('--l-header-height', headerHeight + 'px');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateChromeOffsets);
  } else {
    updateChromeOffsets();
  }

  window.addEventListener('resize', updateChromeOffsets);
  setTimeout(updateChromeOffsets, 100);
  setTimeout(updateChromeOffsets, 500);
})();
